import Base from './Base';

class Deliveries extends Base {
    findById(id = null, opts = null): Promise<Delivery | null> {
        return this.getJSON<Delivery>(`/deliveries/${id}`, null, opts).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }

    findByUrl(url, data, opts = null): Promise<Delivery | null> {
        return this.getJSON<Delivery>(
            '/deliveries',
            {
                url,
                ...data,
            },
            opts,
        ).catch((e) => {
            if (e.status === 404) {
                return null;
            }
            throw e;
        });
    }
}

export default Deliveries;
